import PropTypes from 'prop-types';
import React from 'react';

import DynamicComponent from 'components/dynamicComponent';

const TeamMember = ({ data }) => <DynamicComponent blok={data} key={data._uid} />;

export default TeamMember;

TeamMember.propTypes = {
  data: PropTypes.object.isRequired,
};
